export default __webpack_public_path__ + "static/media/blue.d1b8d1ab.png";